var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedInSmall = function SvgLinkedInSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#335CFF",
    d: "M2.964 1.8a1.2 1.2 0 1 1-2.4-.001 1.2 1.2 0 0 1 2.4.001M3 3.888H.6V11.4H3zm3.792 0H4.404V11.4h2.364V7.458c0-2.196 2.862-2.4 2.862 0V11.4H12V6.642c0-3.702-4.236-3.564-5.232-1.746z"
  })));
};
export default SvgLinkedInSmall;